import { render, staticRenderFns } from "./bigScreenMap.vue?vue&type=template&id=6e24376b&scoped=true&"
import script from "./bigScreenMap.vue?vue&type=script&lang=js&"
export * from "./bigScreenMap.vue?vue&type=script&lang=js&"
import style0 from "./bigScreenMap.vue?vue&type=style&index=0&id=6e24376b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e24376b",
  null
  
)

export default component.exports